<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      >
      </Table>
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";
import { getUsersVrio, deleteUsersVrio as deleteRow } from "@/api/users";

const columns = [
  {
    prop: "id",
    label: "ID",
  },
  {
    prop: "user_vrio",
    label: "ID заместителя",
  },
  {
    prop: "user_vrio_name",
    label: "ФИО заместителя",
  },
  {
    prop: "user_vrio_username",
    label: "@username заместителя",
  },
  {
    prop: "date_from",
    label: "Дата начала",
    type: "date",
  },
  {
    prop: "date_to",
    label: "Дата окончания",
    type: "date",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: {
        sortable: false,
        id: "id",
        editable: true,
        controls: true,
        delete_row: {
          buttonName: "Удалить",
        },
      },
      columns: columns,
      methods: {
        async fetchData(params, { id }) {
          const data = await getUsersVrio({ user_id: id, ...params });
          return data.rows;
        },
        deleteRow,
      },
    };
  },
};
</script>
